import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  DynamicFormControlCustomEvent,
  DynamicFormControlLayout,
  DynamicFormGroupComponent,
  DynamicFormGroupModel,
  DynamicFormLayout,
  DynamicFormLayoutService,
  DynamicFormValidationService,
  DynamicTemplateDirective,
} from '@ng-dynamic-forms/core';
import { DynamicMaterialFormControlContainerComponent } from '../dynamic-material-form-control-container.component';
// import { DynamicMaterialFormControlContainerComponent } from "../dynamic-material-form-control-container.component";

@Component({
  selector: 'dynamic-material-form-group',
  templateUrl: './dynamic-material-form-group.component.html',
  imports: [ReactiveFormsModule, NgClass, DynamicMaterialFormControlContainerComponent],
})
export class DynamicMaterialFormGroupComponent extends DynamicFormGroupComponent {
  @Input() formLayout: DynamicFormLayout;
  @Input() group: FormGroup;
  @Input() layout: DynamicFormControlLayout;
  @Input() model: DynamicFormGroupModel;
  @Input() templates: QueryList<DynamicTemplateDirective> | DynamicTemplateDirective[] | undefined;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  // @ViewChildren(forwardRef(() => DynamicMaterialFormControlContainerComponent))
  // components: QueryList<DynamicMaterialFormControlContainerComponent>;

  constructor(
    protected layoutService: DynamicFormLayoutService,
    protected validationService: DynamicFormValidationService
  ) {
    super(layoutService, validationService);
  }
}
